module.exports = __webpack_public_path__ + "img/UTANTE-1.36f67e18.jpg";